class TableGridAccordionRowController {
  constructor() {
    this.name = 'tableGridAccordionRow';
  }
}

export default TableGridAccordionRowController;



// WEBPACK FOOTER //
// ./app/components/tableGridAccordionRow/tableGridAccordionRow.controller.js